<template>
  <v-list
    v-if="assetList.length != 0"
    subheader
    two-line
    height="450"
    :style="{ 'overflow-y': scrollList }"
  >
    <v-list-item
      v-for="notification in assetList"
      :key="notification.id"
      @click="
        $router.push({
          name: 'NotificationDetailView',
          params: {
            id: notification.id,
          },
        })
      "
    >
      <v-list-item-content class="pa-3">
        <v-btn
          elevation="0"
          rounded
          class="text-right"
          :color="getAlertStatus(notification.alert).color"
        >
          <v-icon :class="getAlertStatus(notification.alert).color" dark>
            {{ getAlertStatus(notification.alert).icon }}
          </v-icon>
          <span class="ml-3">
            {{ $t(getAlertStatus(notification.alert).status) }}
          </span>
          <v-spacer />
          <span>
            {{ $d(notification.alert.date, 'i18nDate') }}
          </span>
        </v-btn>
        <v-tooltip max-width="400" v-if="notification.alert" bottom>
          <template v-slot:activator="{ on, attrs }">
            <div class="pa-2 subtitle" v-bind="attrs" v-on="on">
              {{
                notification.alert.text.length > 37
                  ? notification.alert.text.substring(0, 37) + '...'
                  : notification.alert.text
              }}
            </div>
          </template>
          <div width="300">
            <h2>{{ $d(notification.alert.date) }}</h2>
            {{ notification.alert.text }}
          </div>
        </v-tooltip>
      </v-list-item-content>
    </v-list-item>
  </v-list>
  <v-container v-else style="text-align: center">
    <b>
      <span> {{ $t('emptyTypeAlertList') }} </span>
    </b>
  </v-container>
</template>
<script>
import { getNotificationStatus } from '@/services/notification-service'
import { getAlertStatus } from '@/services/alert-service'

export default {
  props: {
    assetList: {
      type: Array,
    },
  },
  methods: {
    getNotificationStatus(notification) {
      return getNotificationStatus(notification)
    },
    getAlertStatus(status) {
      return getAlertStatus(status)
    },
  },
  computed: {
    scrollList() {
      return this.assetList.length > 5 ? 'scroll' : 'hidden'
    },
  },
}
</script>
